import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const processSteps = [
  {
    id: "extension",
    title: "TRUE EXTENSION OF YOUR FIRM",
    heading: "01. True Extension of Your CPA Firm",
    steps: [
      {
        title: "Benefit-1",
        text: "Integration – We operate as an extension of your team, not just an outsourcing vendor, taking time to understand your workflows and clients.",
      },
      {
        title: "Benefit-2",
        text: "Behind the Scenes – Our team works under your brand, enabling you to scale operations without compromising your firm's identity or client relationships.",
      },
      {
        title: "Benefit-3",
        text: "Consistency – This approach ensures consistency in deliverables and allows your firm to maintain the same quality and professionalism your clients expect.",
      },
    ],
    image: "/images/photos/unsplash-e53a0083.webp",
  },
  {
    id: "cost",
    title: "COST EFFICIENCY",
    heading: "02. Significant Cost Efficiency Without Compromising Quality",
    steps: [
      {
        title: "Benefit-1",
        text: "Cost Optimization – Reduce operational costs substantially while still receiving high-quality, professional services compared to US in-house hiring.",
      },
      {
        title: "Benefit-2",
        text: "Skilled Professionals – Access to skilled accounting professionals at a fraction of the cost of local hires, improving margins significantly.",
      },
      {
        title: "Benefit-3",
        text: "Reinvestment – Reinforce resources into growth-oriented activities such as client acquisition and advisory services.",
      },
    ],
    image: "/images/photos/unsplash-308e3734.webp",
  },
  {
    id: "scalability",
    title: "SCALABILITY",
    heading: "03. Scalability During Peak Seasons and Beyond",
    steps: [
      {
        title: "Benefit-1",
        text: "Flexible Scaling – Gain the flexibility to scale your team up or down based on demand during tax season and financial year-end periods.",
      },
      {
        title: "Benefit-2",
        text: "Burnout Prevention – Avoid missed deadlines, employee burnout, and reduced service quality with additional support when needed.",
      },
      {
        title: "Benefit-3",
        text: "Year-Round Support – Whether you need busy season support or consistent year-round assistance, our team adapts to your requirements.",
      },
    ],
    image: "/images/photos/unsplash-8fc0d702.webp",
  },
  {
    id: "expertise",
    title: "US ACCOUNTING EXPERTISE",
    heading: "04. Deep Expertise in US Accounting and Taxation",
    steps: [
      {
        title: "Benefit-1",
        text: "Multi-State Compliance – Extensive experience in US accounting, bookkeeping, payroll, and multi-state compliance regulations.",
      },
      {
        title: "Benefit-2",
        text: "Tax Returns – Well-versed in various tax return types including individual (1040), corporate (1120), and partnership (1065) filings.",
      },
      {
        title: "Benefit-3",
        text: "Accuracy Guaranteed – All work meets US standards and regulatory requirements, reducing rework and review time.",
      },
    ],
    image: "/images/photos/unsplash-54a0942e.webp",
  },
  {
    id: "turnaround",
    title: "FASTER TURNAROUND",
    heading: "05. Faster Turnaround Times and Improved Efficiency",
    steps: [
      {
        title: "Benefit-1",
        text: "Structured Processes – Our structured processes and dedicated team model enable faster turnaround times without compromising quality.",
      },
      {
        title: "Benefit-2",
        text: "Offload Tasks – By offloading time-consuming tasks to us, your internal team can focus on reviewing, advising, and engaging with clients.",
      },
      {
        title: "Benefit-3",
        text: "Client Satisfaction – Eliminate delays that impact client satisfaction and your firm's reputation.",
      },
    ],
    image: "/images/photos/unsplash-590524b9.webp",
  },
  {
    id: "advisory",
    title: "HIGH-VALUE ADVISORY",
    heading: "06. Focus on High-Value Advisory Services",
    steps: [
      {
        title: "Benefit-1",
        text: "Routine Task Offloading – Outsource bookkeeping, payroll processing, and tax preparation to free up your team's time.",
      },
      {
        title: "Benefit-2",
        text: "Strategic Focus – Shift focus toward high-value services such as tax planning, financial advisory, and client consulting.",
      },
      {
        title: "Benefit-3",
        text: "Revenue Growth – Enhance your firm's value proposition, increase revenue potential, and strengthen client relationships.",
      },
    ],
    image: "/images/photos/unsplash-b41fed58.webp",
  },
  {
    id: "dedicated",
    title: "DEDICATED TEAM",
    heading: "07. Reliable and Dedicated Team Support",
    steps: [
      {
        title: "Benefit-1",
        text: "Consistency – Dedicated team members who understand your processes and work as a consistent point of contact for your firm.",
      },
      {
        title: "Benefit-2",
        text: "No Repeated Training – Eliminates the need for repeated training and ensures continuity in service delivery.",
      },
      {
        title: "Benefit-3",
        text: "Better Outcomes – Our team becomes familiar with your clients and expectations, resulting in smoother collaboration over time.",
      },
    ],
    image: "/images/photos/unsplash-7a3aefc2.webp",
  },
  {
    id: "security",
    title: "DATA SECURITY",
    heading: "08. Strong Data Security and Confidentiality Practices",
    steps: [
      {
        title: "Benefit-1",
        text: "Strict Protocols – Implementing strict data security protocols including secure access controls and encrypted systems.",
      },
      {
        title: "Benefit-2",
        text: "Confidentiality – Confidentiality agreements and processes designed to safeguard client information at every stage.",
      },
      {
        title: "Benefit-3",
        text: "Peace of Mind – Complete peace of mind while outsourcing your accounting functions.",
      },
    ],
    image: "/images/photos/unsplash-4e0aee90.webp",
  },
  {
    id: "technology",
    title: "TECHNOLOGY INTEGRATION",
    heading: "09. Seamless Technology Integration",
    steps: [
      {
        title: "Benefit-1",
        text: "Software Expertise – Experienced in working with tools such as QuickBooks, Xero, and leading US tax software.",
      },
      {
        title: "Benefit-2",
        text: "Smooth Integration – Integrate smoothly into your existing systems without disruption.",
      },
      {
        title: "Benefit-3",
        text: "Workflow Alignment – Workflows remain efficient and aligned with your firm's operations.",
      },
    ],
    image: "/images/photos/unsplash-d6da6221.webp",
  },
  {
    id: "partnership",
    title: "LONG-TERM PARTNERSHIP",
    heading: "10. Long-Term Partnership Approach",
    steps: [
      {
        title: "Benefit-1",
        text: "Relationship Focus – Building long-term relationships rather than short-term engagements.",
      },
      {
        title: "Benefit-2",
        text: "Consistent Value – Consistently delivering value, maintaining high standards, and adapting to your evolving needs.",
      },
      {
        title: "Benefit-3",
        text: "Growth Journey – As your firm expands, we continue to support you with scalable solutions for your growth journey.",
      },
    ],
    image: "/images/photos/unsplash-0e6c0024.webp",
  },
];

export default function Team() {
  const [activeStep, setActiveStep] = useState(0);

  const team = [
    {
      name: "Nishil Shah",
      role: "Chartered Accountant",
      bio: (
        <>
          <p className="mb-4">
            Nishil Shah is a qualified Chartered Accountant with over 10 years
            of experience in US bookkeeping and financial management.
          </p>

          <p className="mb-4">
            He specializes in maintaining accurate financial records, ensuring
            compliance, and supporting businesses with efficient and scalable
            accounting processes.
          </p>

          <div className="mb-4">
            <h4 className="text-sm font-semibold text-[#203468] uppercase tracking-wide mb-2">
              Core Expertise
            </h4>
            <ul className="space-y-2 text-sm text-slate-600">
              <li>
                • <strong>US Bookkeeping:</strong> Structured systems, daily
                transactions, and accurate reporting
              </li>
              <li>
                • <strong>Payroll Taxes:</strong> Multi-state compliance with
                timely filings
              </li>
              <li>
                • <strong>Sales Taxes:</strong> Registrations, filings, and
                audit support across states
              </li>
              <li>
                • <strong>Year-End Taxes:</strong> Optimized financials for
                smooth tax filing
              </li>
            </ul>
          </div>

          <p>
            Known for his precision and proactive approach, Nishil helps
            businesses maintain strong financial health while staying compliant
            with evolving regulations.
          </p>
        </>
      ),
      image: "/images/nishil.webp",
    },
    {
      name: "Nikunj Savani",
      role: "CPA (US), Chartered Accountant",
      bio: (
        <>
          <p className="mb-4">
            Nikunj Savani is a dual-qualified Chartered Accountant (CA) and US
            Certified Public Accountant (CPA) with over 5 years of specialized
            experience in US taxation.
          </p>

          <p className="mb-4">
            He brings deep expertise across individual, corporate, and
            partnership tax laws, enabling him to handle complex tax scenarios
            with precision and strategic insight.
          </p>

          <div className="mb-4">
            <h4 className="text-sm font-semibold text-[#203468] uppercase tracking-wide mb-2">
              Core Expertise
            </h4>
            <ul className="space-y-2 text-sm text-slate-600">
              <li>
                • <strong>Individual Tax Returns (1040):</strong> Optimizing
                deductions and maximizing refunds
              </li>
              <li>
                • <strong>Corporate Tax Returns (1120, 1120-S):</strong>{" "}
                Compliance and strategic tax planning for corporations
              </li>
              <li>
                • <strong>Partnership Returns (1065):</strong> Expertise in LLCs
                and partnership tax structures
              </li>
              <li>
                • <strong>Tax Planning & Advisory:</strong> Proactive strategies
                to minimize tax liabilities effectively
              </li>
            </ul>
          </div>

          <p>
            Known for his meticulous approach and up-to-date knowledge of
            evolving tax laws, Nikunj delivers accurate, compliant, and
            value-driven tax solutions to his clients.
          </p>
        </>
      ),
      image: "/images/nikunj.jpeg",
    },
  ];

  // Split processSteps into two columns
  const firstColumn = processSteps.slice(0, 5);
  const secondColumn = processSteps.slice(5, 10);

  return (
    <div className="bg-white min-h-screen pt-28">
      {/* Editorial Header */}
      <div className="relative overflow-hidden bg-[#203468] py-16 lg:py-24 text-white">
        {/* 🔷 Animated grid background */}
        <div className="absolute inset-0 grid-bg opacity-20"></div>

        {/* 🔵 Moving gradient beam */}
        <div className="absolute inset-0">
          <div className="gradient-beam"></div>
        </div>

        {/* 🟣 Floating particles */}
        <div className="absolute inset-0 pointer-events-none">
          <span className="particle w-2 h-2 left-[10%] top-[20%]"></span>
          <span className="particle w-3 h-3 left-[70%] top-[40%]"></span>
          <span className="particle w-2 h-2 left-[50%] top-[70%]"></span>
          <span className="particle w-3 h-3 left-[30%] top-[80%]"></span>
        </div>

        {/* 🧊 Glass layer */}
        <div className="absolute inset-0 backdrop-blur-md bg-white/5"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl">
            {/* 🔥 Animated heading */}
            <h1 className="font-serif text-5xl lg:text-7xl leading-tight mb-8">
              <span className="word">The Alpha CPAs</span>{" "}
              <span className="word text-blue-400 italic">Leadership Team</span>
            </h1>

            {/* ✨ Subtitle */}
            <p className="text-slate-300 text-xl leading-relaxed max-w-2xl fade-up delay-2">
              Meet the distinguished partners and directors dedicated to
              architecting your financial success.
            </p>

            {/* 🚀 CTA */}
            <div className="mt-8 fade-up delay-3">
              <div className="mt-6 fade-up delay-3">
                <button
                  onClick={() => {
                    document.getElementById("benefits")?.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  }}
                  className="relative inline-block px-8 py-3 rounded-full bg-blue-500 border border-white text-white overflow-hidden group"
                >
                  <span className="relative z-10">Explore Benefits</span>

                  <span className="absolute inset-0 bg-blue-400 opacity-0 group-hover:opacity-20 blur-xl transition-all duration-500"></span>
                  <span className="shine"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Team Grid - High-end Law/Accounting Firm Style */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div className="grid grid-cols-1 md:grid-rows-2 gap-x-12 gap-y-20">
          {team.map((member, index) => (
            <div
              key={index}
              className={`group flex flex-col ${index === 1 ? 'sm:flex-row-reverse' : 'sm:flex-row'} gap-8 items-start`}
            >
              <div className="w-full sm:w-2/5 shrink-0 overflow-hidden bg-slate-100">
                <img
                  width="400"
                  height="400"
                  loading="eager"
                  decoding="async"
                  src={member.image}
                  alt={member.name}
                  className="object-cover w-full aspect-[1/1] grayscale group-hover:grayscale-0 transition-all duration-700"
                  referrerPolicy="no-referrer"
                />
              </div>
              <div className="w-full sm:w-3/5 flex flex-col justify-center pt-4 sm:pt-8">
                <h3 className="font-serif text-3xl text-[#203468] mb-2">
                  {member.name}
                </h3>
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-700 mb-6">
                  {member.role}
                </p>
                <div className="w-12 h-px bg-slate-300 mb-6 group-hover:bg-blue-700 transition-colors duration-500"></div>
                <div className="text-slate-600 leading-relaxed font-light space-y-4">
                  {Array.isArray(member.bio) ? (
                    member.bio.map((para, i) => <p key={i}>{para}</p>)
                  ) : (
                    <p>{member.bio}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Our Process Section */}
      <div className="bg-slate-50 py-24 lg:py-32" id="benefits">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-blue-600 text-sm font-bold uppercase tracking-[0.2em] mb-4">
              What You Gain
            </h2>
            <h3 className="font-serif text-4xl lg:text-5xl text-[#203468]">
              Benefits at a Glance
            </h3>
          </div>

          <div className="flex flex-col lg:flex-row gap-8 items-start">
            {/* Left Navigation - Two Columns */}
            <div className="w-full lg:w-1/3 shrink-0 bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] py-6 px-6">
              <div className="grid grid-cols-2 gap-0">
                {/* First Column */}
                <div>
                  <ul className="flex flex-col">
                    {firstColumn.map((step, index) => {
                      const isActive = activeStep === index;
                      return (
                        <li key={step.id}>
                          <button
                            onClick={() => setActiveStep(index)}
                            className={`w-full text-left py-4 pr-4 flex items-center gap-4 transition-colors relative ${
                              isActive
                                ? "text-yellow-500 font-semibold pl-10"
                                : "text-slate-500 hover:text-slate-900 pl-10"
                            }`}
                          >
                            {isActive && (
                              <motion.div
                                layoutId="activeProcessTab"
                                className="absolute left-0 top-1/2 -translate-y-1/2 w-6 h-[2px] bg-yellow-500"
                              />
                            )}
                            <span className="text-sm shrink-0">
                              {index + 1}.
                            </span>
                            <span className="text-sm tracking-wide uppercase">
                              {step.title}
                            </span>
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>

                {/* Second Column */}
                <div>
                  <ul className="flex flex-col">
                    {secondColumn.map((step, index) => {
                      const isActive = activeStep === index + 5;
                      return (
                        <li key={step.id}>
                          <button
                            onClick={() => setActiveStep(index + 5)}
                            className={`w-full text-left py-4 pr-4 flex items-center gap-4 transition-colors relative ${
                              isActive
                                ? "text-yellow-500 font-semibold pl-10"
                                : "text-slate-500 hover:text-slate-900 pl-10"
                            }`}
                          >
                            {isActive && (
                              <motion.div
                                layoutId="activeProcessTab"
                                className="absolute left-0 top-1/2 -translate-y-1/2 w-6 h-[2px] bg-yellow-500"
                              />
                            )}
                            <span className="text-sm shrink-0">
                              {index + 6}.
                            </span>
                            <span className="text-sm tracking-wide uppercase">
                              {step.title}
                            </span>
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>

            {/* Right Content Area */}
            <div className="w-full lg:w-2/3 bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-8 md:p-12 min-h-[500px]">
              <AnimatePresence mode="wait">
                <motion.div
                  key={activeStep}
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -20 }}
                  transition={{ duration: 0.4 }}
                >
                  {/* 1. The Main Heading */}
                  <h3 className="text-3xl font-bold text-[#203468] mb-12">
                    {processSteps[activeStep].heading}
                  </h3>

                  <div className="flex flex-col md:flex-row gap-12 items-start">
                    {/* 2. THE TIMELINE SECTION (PASTE HERE) */}
                    <div className="w-full md:w-3/5 relative">
                      {/* The Vertical Dashed Line */}
                      <div className="timeline-vertical-line"></div>

                      <div className="flex flex-col">
                        {processSteps[activeStep].steps.map((step, i) => (
                          <div key={i} className="timeline-items">
                            {/* The Orange Dot */}
                            <div className="timeline-dots"></div>

                            <div className="flex flex-col">
                              {/* "Step-1" Label */}
                              <span className="timeline-step-label">
                                {step.title}
                              </span>

                              {/* The Bold/Light Text Block */}
                              <p className="timeline-contents">
                                <strong>
                                  {step.text.includes(" – ")
                                    ? step.text.split(" – ")[0]
                                    : step.text}
                                </strong>
                                {step.text.includes(" – ") && (
                                  <span> – {step.text.split(" – ")[1]}</span>
                                )}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* 3. The Illustration Image */}
                    <div className="w-full md:w-2/5 flex justify-center items-center">
                      <img
                        loading="eager"
                        decoding="async"
                        src={processSteps[activeStep].image}
                        className="w-full max-w-[350px] object-contain opacity-90"
                        alt="Process Illustration"
                      />
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
